import {withDispatchActions} from "../../../../shared/hoc/withDispatchActions";
import TagItem from "../../../pages/tags-info/tag-item";
import {toggleFenceEditModeActions} from "../FencesContainer.helpers";

const TagItemWithToggleActions = withDispatchActions(TagItem, toggleFenceEditModeActions);

export default TagItemWithToggleActions;